<template>
  <div class="login-page">
    <div class="logo">
        <Logo />
    </div>

    <div class="present-container">
        <div class="present-container-flex">
            <h2>Crea</h2>
            <p>Crea un evento como por ejemplo una quedada de antiguos compañeros de curso</p>   

            <h2>Comparte</h2>
            <p>Comparte el código generado a todos los que quieras que formen parte del evento</p>
            <h2>Vota</h2>
            <p>Se positivo y vota que si, seguro que todos los participantes estaran contentos de tu participación</p>
        </div>
    </div>
    
    <div class="auth-container">
        <div class="auth-container-flex">
            <h1>Login</h1>
            <div id="firebaseui-auth-container">
                <h2>Gratis por tiempo ilimitado</h2>
            </div>
        </div>
        
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import * as firebaseui from 'firebaseui'
import Logo from './Logo'

export default {
    name: 'Login',
    components: {
        Logo
    },

    mounted() {
        this.login();
    },
    methods: {
        login() {

            let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
            
            // FirebaseUI config.
            var uiConfig = {
                signInSuccessUrl:  this.$router.push('/').catch(e => console.log(e) ),
                //signInSuccessUrl: this.$router.replace('/home'), //this.$router.replace({name:'Home'}),
                signInOptions: [
                    // Leave the lines as is for the providers you want to offer your users.
                    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                ],

                signInFlow: 'popup',
                // Terms of service url/callback.
                tosUrl: '<your-tos-url>',

                // Privacy policy url/callback.
                privacyPolicyUrl: function () {
                    window.location.assign('<your-privacy-policy-url>');
                }
            };
           
            // The start method will wait until the DOM is loaded.
             ui.start('#firebaseui-auth-container', uiConfig);
        }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
@import '@/assets/styles/main.scss';
</style>
